import React from 'react';
import { BrowserRouter as Router, Routes, Route,  Navigate } from 'react-router-dom';

// --- Page Imports ---
import BlogList from './pages/BlogList';
import BlogForm from './pages/BlogForm';
import JobList from './pages/JobList';
import JobForm from './pages/JobForm';
import ApplicantList from './pages/ApplicantList';
import GalleryManager from './pages/GalleryManager';
import Messages from './pages/Messages';

// --- Auth Imports ---
import ProtectedRoute from './Component/ProtectedRoute';
import Login from './Auth/Login';
import SignUp from './Auth/SignUp';

// ✅ 1. Import your new, separate AdminLayout component
import AdminLayout from './Component/AdminLayout'; // <-- Adjust path as needed
import AdminHome from './pages/AdminHome';


// 2. ❌ The old AdminLayout function has been DELETED from this file


function App() {
  return (
    <Router>
      <Routes>
        {/* ====================================================== */}
        {/* 1. PUBLIC ROUTES (Login & Signup) */}
        {/* ====================================================== */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />

        {/* ====================================================== */}
        {/* 2. PROTECTED ADMIN PANEL */}
        {/* This logic is IDENTICAL, but it now uses your new component */}
        {/* ====================================================== */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              {/* ✅ This now renders your beautiful new layout */}
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          {/* These paths are relative to "/admin" */}
          <Route path="dashboard" element={<BlogList />} />
          <Route path="blog/new" element={<BlogForm />} />
          <Route path="blog/edit/:id" element={<BlogForm />} />
          <Route path="careers" element={<JobList />} />
          <Route path="home" element={<AdminHome />} />
          <Route path="career/new" element={<JobForm />} />
          <Route path="career/edit/:id" element={<JobForm />} />
          <Route path="applicants" element={<ApplicantList />} />
          <Route path="gallery" element={<GalleryManager />} />
          <Route path="messages" element={<Messages />} />
          
          {/* This makes "/admin" redirect to "/admin/dashboard" */}
          <Route index element={<Navigate to="dashboard" replace />} />
        </Route>

        {/* ====================================================== */}
        {/* 3. FALLBACK ROUTE */}
        {/* ====================================================== */}
        <Route path="/" element={<Navigate to="/login" replace />} />

      </Routes>
    </Router>
  );
}

export default App;